import { makeVar } from "@apollo/client";

// Reactive variable to store GraphQL errors
export const apolloErrorVar = makeVar<Error | null>(null);
